;(function(jQuery){

	"use strict";

	function People()
	{
		var fn = {
			init: function()
			{
				var peopleElements = jQuery('.people');

				if (!peopleElements.length) {
					return;
				}

				var windowWidth = jQuery(window).width();
				if (windowWidth < 930)
				{
					return; // don't equalise heights on mobile
				}

				peopleElements.each(function(i, cardGrid) {
					var items = jQuery(cardGrid).find('.people__item');
					fn.handleRows(3, items);
				});

			},

			handleRows: function(columnCount, items)
			{
				var row = [];

				items.each(function(i, card) {
					row.push(card);
					if ((i + 1) % columnCount === 0 || (i + 1) == items.length)
					{
						fn.equaliseHeights(row);
						row = []; // empty the array for next row
					}
				});
			},

			equaliseHeights: function(row)
			{
				var headings = jQuery(row).find('.people__name');
				var jobtitles = jQuery(row).find('.people__heading--small');
				var quotes = jQuery(row).find('.people-about');
				var elementGroups = [headings, jobtitles, quotes];

				jQuery(elementGroups).each(function(i, elementGroup) {
					var largestElement = fn.getLargestHeight(elementGroup);

					elementGroup.each(function(i, element) {
						jQuery(element).css('min-height', largestElement);
					});
				});
			},

			getLargestHeight: function(elems)
			{
				var largest = 0;
				elems.each(function(i, elem) {
					var elemHeight = jQuery(elem).height();
					if (elemHeight > largest)
					{
						largest = elemHeight;
					}
				});

				return largest;
			}
		}

		jQuery(fn.init);
	}

	new People();
})(jQuery);